import { render, staticRenderFns } from "./Exchange.vue?vue&type=template&id=69e0e9d6&scoped=true"
import script from "./Exchange.vue?vue&type=script&setup=true&lang=js"
export * from "./Exchange.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Exchange.vue?vue&type=style&index=0&id=69e0e9d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69e0e9d6",
  null
  
)

export default component.exports